import { useNavigate } from "react-router-dom";
import { MainService } from "../../types/homeComponentTypes";
interface Props {
  mainServices: MainService[];
  data?: {
    heading: string;
    image: string;
  };
}
// import {
//   BannerWrap,
//   Container,
//   Row,
//   LeftColumn,
//   HeadingStyle,
//   BannerServicess,
//   ServiceRow,
//   RightColumn,
//   MainBanner,
// } from "./bannerServicesStyled";

declare global {
  interface Window {
    // WOW: any; // Declare `WOW` on the window object as `any`
  }
}

const BannerServices: React.FC<Props> = ({ mainServices, data }) => {
  const navigate = useNavigate();

  const handleNewPage = (slug: string) => {
    // if (slug === "packages") {
    //   navigate("/visa-packages-dubai");
    // }else {
    navigate(`/services/${slug}`);
    // }
  };
  return (
    <section className="banner-wrap py-3 py-md-5">
      <div className="container ">
       
        <div className="row align-items-stretch d-flex h-100">
          {/* Left Column */}
          <div className="col-md-6 d-flex flex-column">
            <div className="hd-style-1 wow animate__fadeInLeft d-none d-md-block ">
              <h1
                dangerouslySetInnerHTML={{
                  __html: data?.heading ?? "",
                }}
              ></h1>
            </div>
            <div className="banner-services mt-auto border">
              <div className="sub-hd1 wow fadeInUp d-none d-md-block">
                <p>What you are looking for</p>
              </div>
              <div className="row">
                {mainServices.map((card) => (
                  <div
                    className="col-md-4 col-lg-4 col-4"
                    key={card.sub2RecordId + card.sub1Slug}
                    onClick={() => handleNewPage(card.sub1Slug)}
                  >
                    <div
                      className="banner-sr-card wow animate__zoomIn "
                      data-wow-duration="1s"
                      data-wow-delay="0s"
                    >
                      <img
                        loading="lazy"
                        src={card.sub1ImageSrc}
                        alt={card.sub1ImgAlt + card.sub2RecordId}
                        className="img-fluid mx-auto d-block"
                      />
                    </div>
                    <p>{card.sub1ServiceName}</p>
                    {/* </Link> */}
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Column */}
          <div className="col-md-6 d-flex align-items-center justify-content-center d-none d-md-block">
            <div
              className="main-banner w-100 h-100 wow animate__zoomIn "
              data-wow-duration="2s"
              data-wow-delay="0s"
            >
              <img
                src="https://goodhand.b-cdn.net/Assets/Home/Mix/banner-side-Dh1vO77i.svg"
                alt="banner img"
                className="img-fluid wow w-100 h-100 object-fit-cover cursor-pointer"
              />
            </div>
          </div>
        </div>
        
      </div>
    </section>
  //   <BannerWrap>
  //   <Container>
  //     <Row>
  //       {/* Left Column */}
  //       <LeftColumn>
  //         <HeadingStyle>
  //           <h1
  //             dangerouslySetInnerHTML={{
  //               __html: data?.heading ?? "",
  //             }}
  //           ></h1>
  //         </HeadingStyle>
  //         <BannerServicess>
  //           <div className="sub-heading">
  //             <p>What you are looking for</p>
  //           </div>
  //           <ServiceRow>
  //             {mainServices.map((card) => (
  //               <div
  //                 className="service-card"
  //                 key={card.sub2RecordId + card.sub1Slug}
  //                 onClick={() => handleNewPage(card.sub1Slug)}
  //               >
  //                 <div className="banner-sr-card">
  //                   <img
  //                     loading="lazy"
  //                     src={card.sub1ImageSrc}
  //                     alt={card.sub1ImgAlt + card.sub2RecordId}
  //                   />
  //                 </div>
  //                 <p>{card.sub1ServiceName}</p>
  //               </div>
  //             ))}
  //           </ServiceRow>
  //         </BannerServicess>
  //       </LeftColumn>

  //       {/* Right Column */}
  //       <RightColumn>
  //         <MainBanner>
  //           <img
  //             src="https://goodhand.b-cdn.net/Assets/Home/Mix/banner-side-Dh1vO77i.svg"
  //             alt="banner img"
  //           />
  //         </MainBanner>
  //       </RightColumn>
  //     </Row>
  //   </Container>
  // </BannerWrap>
  );
};

export default BannerServices;
